module.exports = __webpack_public_path__ + "static/media/access-third@3x.44100bec.jpg";